import React from 'react'

import styles from './styles';

export default function Header({ headerText }) {
    const classes = styles();

    return (
        <div className={classes.header}>{headerText}</div>
    )
}
